import { useCurrentUserId } from '@/features/user/currentUser.service';
import { Avatar, message, notification } from 'antd';
import React from 'react';
import { NotificationContentPart } from '../../../api/notification/notification.dto';
import { useApiWebSocket } from '../../../hooks/useApiWebSocket';
import routes from '../../../routes/routes';
import { formatDateTime } from '../../../utils/datetime';
import UnreachableCaseError from '../../../utils/UnreachableCaseError';

const notificationHideDelaySec = 10;
const chatMessageHideDelaySec = 5;
const defaultProfilePhoto = '/images/defaultProfileImage.jpg';

export function renderNotificationContentPart(content: NotificationContentPart): React.ReactNode {
  switch (content.type) {
    case 'text':
      return content.value;
    case 'link':
      return <a href={content.value}>{content.label}</a>;
    case 'datetime':
      return formatDateTime(content.value);
    default:
      throw new UnreachableCaseError(content);
  }
}

export const NotificationManager = () => {
  const currentUserId = useCurrentUserId();

  useApiWebSocket({
    onMessage(msg) {
      if (msg.type === 'notification') {
        notification.info({
          message: msg.notification.title,
          description: msg.notification.content
            .map(renderNotificationContentPart)
            .map((el, i) => <React.Fragment key={i}>{el}</React.Fragment>),
          placement: 'top',
          duration: notificationHideDelaySec,
          type: 'info',
          style: { width: 'max-content' },
        });
      }
      if (msg.type === 'chatMessage' && msg.message.sender.id !== currentUserId) {
        message.info(
          <div>
            <div className="flex flex-row justify-center items-center">
              <Avatar
                className="mx-2"
                size="large"
                src={msg.message.sender.profilePhoto ?? defaultProfilePhoto}
              />
              <p className="inline-flex">
                <p> New Message Received From</p>
                <a
                  className="ml-1 text-blue-41"
                  href={routes.showcase({ userId: msg.message.sender.id })}
                >
                  {msg.message.sender.userName}
                </a>
              </p>
            </div>
            <div className="flex flex-row justify-center items-center">
              <span>{msg.message.message}</span>
            </div>
          </div>,
          chatMessageHideDelaySec,
        );
      }
    },
  });

  return null;
};
